import {
  SET_USERS,
  DELETE_USER,
  SET_SELECTED_USER,
  SET_ONLINE_USERS
} from '../actions/types';

const initialState = {
  selectedUser: {
    id: '',
    email: '',
    first_name: '',
    last_name: '',
    phone: '',
    profile_photo_url: '',
    roles: [],
    project: null,
    projects: []
  },
  allUsers: [],
  onlineUsers: []
}

export function user(state = initialState, action = {}) {
  switch (action.type) {
    case SET_USERS:
      return Object.assign({}, state, { allUsers: action.users });
    case DELETE_USER:
      const allUsers = state.allUsers.filter(u => u.id !== action.userId);
      return Object.assign({}, state, { allUsers });
    case SET_SELECTED_USER:
      return Object.assign({}, state, { selectedUser: action.user });
    case SET_ONLINE_USERS:
      return Object.assign({}, state, { onlineUsers: action.users });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/user.js